// Core
import React, { useState } from 'react';
import Slider from 'react-slick';
import { Box, Text, Button, Image, useBreakpointValue } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Components
import { galleryList } from './DataList';

const BuiltDifferent = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const settings = {
        dots: false, 
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0%',
        autoplay: true,
        autoplaySpeed: 2000, 
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        nextArrow: <></>,
        prevArrow: <></>,
    };

    const responsiveSettings = useBreakpointValue({
        base: {...settings, slidesToShow: 1, dots: true}, 
        md: settings 
    });

    const responsiveClass = useBreakpointValue({
        base: '', 
        md: 'slider-build-different'
    });

    return (
        <Box 
          position="relative"
          className={responsiveClass}
          left="50%"
          transform="translateX(-50%)"
          width={{base: '100%', sm: '90vw', md: '100vw'}}
          zIndex="1"
          overflow="visible"
          whiteSpace="nowrap">
          <Box 
              position="relative"
              left="50%"
              transform="translateX(-50%)"
              width={{base: '100%', sm: '90vw', md: '120vw'}}
              zIndex="1"
              overflow="visible"
              py={{base: '24px', md: '30px'}}
              whiteSpace="nowrap">
            <Slider {...responsiveSettings}>
                {galleryList.map((image, index) => (
                    <Box
                        key={index}
                        borderRadius="16px"
                        transition="transform 0.3s ease"
                        px={{base: '0px', md: '12px'}}
                    >
                        <>  
                            <Box position="relative" zIndex="1" mb="-1px" borderRadius="12px" 
                                border="unset">
                                <Image 
                                    src={image} 
                                    alt="Gallery" 
                                    w="100%" 
                                    transform={{ base: index === currentSlide ? 'scale(1)' : 'scale(0.9)', md: 'unset'}}
                                    opacity={{ base: index === currentSlide ? '1' : '0.6', md: '1'}}
                                    h={{base: '211px', md: '392px'}} 
                                    borderRadius="11px" 
                                    objectFit="cover" />
                            </Box>
                        </>
                    </Box>
                ))}
            </Slider>
          </Box>
        </Box>
    );
};

export default BuiltDifferent;